import { useLocaleStore, type Locale } from '../stores/locale';

type Dict = Record<string, { sr: string; en: string }>;

const dict: Dict = {
  'lang.sr': { sr: 'SR', en: 'SR' },
  'lang.en': { sr: 'EN', en: 'EN' },

  'nav.feed': { sr: 'Feed', en: 'Feed' },
  'nav.group.match': { sr: 'Utakmice', en: 'Matches' },
  'nav.group.broadcast': { sr: 'Prenos', en: 'Broadcast' },
  'nav.group.media': { sr: 'Mediji', en: 'Media' },
  'nav.group.org': { sr: 'Organizaciono', en: 'Organisation' },
  'nav.account': { sr: 'Nalog', en: 'Account' },
  'nav.home': { sr: 'Početna', en: 'Home' },
  'nav.matches': { sr: 'Utakmice', en: 'Matches' },
  'nav.rounds': { sr: 'Kola', en: 'Rounds' },
  'nav.discipline': { sr: 'Disciplina', en: 'Discipline' },
  'nav.venues': { sr: 'Dvorane', en: 'Venues' },
  'nav.clips': { sr: 'Klipovi', en: 'Clips' },
  'nav.studio': { sr: 'Brand Studio', en: 'Brand Studio' },
  'nav.videos': { sr: 'Video', en: 'Videos' },
  'nav.setup': { sr: 'Setup', en: 'Setup' },
  'nav.clubs': { sr: 'Klubovi', en: 'Clubs' },
  'nav.keys': { sr: 'API ključevi', en: 'API keys' },
  'nav.sites': { sr: 'Sajtovi', en: 'Sites' },
  'nav.usage': { sr: 'Potrošnja', en: 'Usage' },
  'nav.webhooks': { sr: 'Webhooks', en: 'Webhooks' },
  'nav.signout': { sr: 'Odjava', en: 'Sign out' },
  'nav.accountBtn': { sr: 'Nalog', en: 'Account' },
  'nav.collapse': { sr: 'Skupi meni', en: 'Collapse sidebar' },
  'nav.expand': { sr: 'Proširi meni', en: 'Expand sidebar' },
  'nav.client': { sr: 'Klijent', en: 'Client' },
  'nav.league': { sr: 'Liga', en: 'League' },
  'nav.club': { sr: 'Klub', en: 'Club' },
  'nav.press': { sr: 'Press', en: 'Press' },
  'nav.sponsor': { sr: 'Sponzor', en: 'Sponsor' },
  'nav.cards': { sr: 'Kartice', en: 'Cards' },
  'nav.social': { sr: 'Social', en: 'Social' },
  'nav.scouting': { sr: 'Scouting', en: 'Scouting' },
  'nav.history': { sr: 'Sezona', en: 'Season' },
  'nav.wire': { sr: 'Wire', en: 'Wire' },
  'nav.onair': { sr: 'On-Air', en: 'On-Air' },
  'nav.line': { sr: 'Line', en: 'Line' },

  'login.title': { sr: 'Prijava', en: 'Sign in' },
  'login.sub': { sr: 'Origo klijent', en: 'Origo client' },
  'login.email': { sr: 'Email', en: 'Email' },
  'login.password': { sr: 'Lozinka', en: 'Password' },
  'login.show': { sr: 'Prikaži', en: 'Show' },
  'login.hide': { sr: 'Sakrij', en: 'Hide' },
  'login.continue': { sr: 'Nastavi', en: 'Continue' },
  'login.signing': { sr: 'Prijava…', en: 'Signing in…' },

  'handoff.missing': { sr: 'Nema handoff tokena. Vrati se u admin i ponovo otvori portal.', en: 'Missing handoff token. Go back to admin and try Open portal again.' },
  'handoff.fail': { sr: 'Handoff nije uspeo', en: 'Handoff failed' },
  'handoff.signing': { sr: 'Prijava…', en: 'Signing you in…' },

  'home.kicker': { sr: 'Klub', en: 'Club' },
  'home.title': { sr: 'Početna', en: 'Home' },
  'home.sub': { sr: 'Sledeći meč, embed pack, sastav, lozinka i share — sve na jednom mestu.', en: 'Next match, embed pack, squad, password and share — one screen.' },
  'home.league': { sr: 'Liga', en: 'League' },
  'home.next': { sr: 'Sledeći meč', en: 'Next match' },
  'home.lastFt': { sr: 'Poslednji FT', en: 'Last FT' },
  'home.liveNow': { sr: 'Uživo', en: 'Live now' },
  'home.noMatch': { sr: 'Još nema utakmice u rasporedu.', en: 'No entitled match yet.' },
  'home.openMatches': { sr: 'Utakmice →', en: 'Matches →' },
  'home.zapisnik': { sr: 'Zapisnik', en: 'Match report' },
  'home.highlight': { sr: 'Napravi highlight', en: 'Create highlight' },
  'home.copyStory': { sr: 'Kopiraj story', en: 'Copy story' },
  'home.copied': { sr: 'Kopirano', en: 'Copied' },
  'home.embedTitle': { sr: 'Embed pack', en: 'Embed pack' },
  'home.embedSub': { sr: 'Live, tabela i story za sajt kluba. Zameni YOUR_WIDGET_KEY ključem sa API ključeva.', en: 'Live, standings and story for the club site. Replace YOUR_WIDGET_KEY with a key from API keys.' },
  'home.copyPack': { sr: 'Kopiraj pack', en: 'Copy pack' },
  'home.squad': { sr: 'Moji igrači', en: 'My players' },
  'home.squadEmpty': { sr: 'Nema aktivnog sastava za ovaj tim.', en: 'No active roster for this team.' },
  'home.shirt': { sr: 'Br.', en: 'No.' },
  'home.player': { sr: 'Igrač', en: 'Player' },
  'home.role': { sr: 'Uloga', en: 'Role' },
  'home.password': { sr: 'Promena lozinke', en: 'Reset password' },
  'home.passwordSub': { sr: 'Sekretar menja lozinku ovog portala. Liga i dalje može da je resetuje sa Clubs.', en: 'The secretary changes this portal password. The league can still reset it from Clubs.' },
  'home.currentPw': { sr: 'Trenutna lozinka', en: 'Current password' },
  'home.newPw': { sr: 'Nova lozinka', en: 'New password' },
  'home.confirmPw': { sr: 'Potvrdi novu', en: 'Confirm new' },
  'home.savePw': { sr: 'Sačuvaj lozinku', en: 'Save password' },
  'home.calendar': {
    sr: 'Kalendar utakmica (Google, Apple, Outlook — pretplata):',
    en: 'Match calendar (Google, Apple, Outlook — subscribe):',
  },
  'home.copyLink': { sr: 'Kopiraj link', en: 'Copy link' },
  'brand.title': { sr: 'Grb i boje kluba', en: 'Club crest & colors' },
  'brand.sub': {
    sr: 'Pošalji novi grb (PNG, JPEG, WebP ili SVG do 2 MB) i boje. Liga odobrava pre nego što se pojavi u widgetima.',
    en: 'Submit a new crest (PNG, JPEG, WebP or SVG up to 2 MB) and colors. The league approves it before it shows in widgets.',
  },
  'brand.current': { sr: 'Trenutni grb', en: 'Current crest' },
  'brand.none': { sr: 'Nema grba', en: 'No crest yet' },
  'brand.primary': { sr: 'Primarna boja', en: 'Primary color' },
  'brand.secondary': { sr: 'Sekundarna boja', en: 'Secondary color' },
  'brand.pick': { sr: 'Izaberi fajl', en: 'Choose file' },
  'brand.submit': { sr: 'Pošalji na odobrenje', en: 'Submit for approval' },
  'brand.sending': { sr: 'Slanje…', en: 'Sending…' },
  'brand.pending': { sr: 'Čeka odobrenje lige', en: 'Waiting for league approval' },
  'brand.sent': { sr: 'Poslato ligi na odobrenje.', en: 'Sent to the league for approval.' },
  'brand.tooBig': { sr: 'Fajl mora biti do 2 MB.', en: 'File must be at most 2 MB.' },
  'brand.requests': { sr: 'Zahtevi za grb', en: 'Crest requests' },
  'brand.requestsSub': {
    sr: 'Klubovi su poslali novi grb. Odobreni grb odmah ide u widgete, izveštaje i On-Air.',
    en: 'Clubs submitted a new crest. Approved crests go live in widgets, reports and On-Air right away.',
  },
  'brand.approve': { sr: 'Odobri', en: 'Approve' },
  'brand.reject': { sr: 'Odbij', en: 'Reject' },
  'home.pwSaved': { sr: 'Lozinka je promenjena.', en: 'Password updated.' },
  'home.pwMismatch': { sr: 'Nove lozinke se ne poklapaju.', en: 'New passwords do not match.' },
  'home.share': { sr: 'Share', en: 'Share' },
  'home.shareSub': { sr: 'Story snippet za Instagram / sajt. Match ID je sledeći ili poslednji FT.', en: 'Story snippet for Instagram / the site. Match ID is the next or last FT.' },
  'home.saving': { sr: 'Čuvanje…', en: 'Saving…' },
  'home.captain': { sr: 'kapiten', en: 'captain' },

  'matches.sub': { sr: 'Utakmice na licenci — embed, zapisnik, zvanično.', en: 'Entitled fixtures — embed, report, official stamp.' },
  'matches.rounds': { sr: 'Kola →', en: 'Rounds →' },
  'hello.morning': { sr: 'Dobro jutro', en: 'Good morning' },
  'hello.day': { sr: 'Dobar dan', en: 'Good afternoon' },
  'hello.evening': { sr: 'Dobro veče', en: 'Good evening' },
  'hello.liveN': { sr: '{n} uživo sada · podaci teku u realnom vremenu', en: '{n} live now · data is streaming in real time' },
  'hello.upcomingN': { sr: '{n} predstojećih utakmica na licenci', en: '{n} upcoming matches on your license' },
  'hello.quiet': { sr: 'Trenutno nema utakmica uživo', en: 'No live matches right now' },
  'stat.live': { sr: 'Uživo', en: 'Live' },
  'stat.liveHint': { sr: 'u toku', en: 'in play' },
  'stat.upcoming': { sr: 'Predstojeće', en: 'Upcoming' },
  'stat.upcomingHint': { sr: 'zakazano', en: 'scheduled' },
  'stat.ft': { sr: 'Završene', en: 'Finished' },
  'stat.ftHint': { sr: 'full time', en: 'full time' },
  'stat.all': { sr: 'Ukupno', en: 'Total' },
  'stat.allHint': { sr: 'na licenci', en: 'on your license' },
  'matches.license': { sr: 'Licenca', en: 'License' },
  'matches.sports': { sr: 'Sportovi', en: 'Sports' },
  'matches.competitions': { sr: 'Takmičenja', en: 'Competitions' },
  'matches.delay': { sr: 'Delay', en: 'Delay' },
  'matches.club': { sr: 'Klub', en: 'Club' },
  'matches.league': { sr: 'Liga', en: 'League' },
  'matches.clubPortals': { sr: 'Portali klubova', en: 'Club portals' },
  'matches.upcoming': { sr: 'Predstojeće', en: 'Upcoming' },
  'matches.live': { sr: 'Uživo', en: 'Live' },
  'matches.ft': { sr: 'FT', en: 'FT' },
  'matches.all': { sr: 'Sve', en: 'All' },
  'matches.kickoff': { sr: 'Početak', en: 'Kickoff' },
  'matches.match': { sr: 'Utakmica', en: 'Match' },
  'matches.competition': { sr: 'Takmičenje', en: 'Competition' },
  'matches.coverage': { sr: 'Pokrivenost', en: 'Coverage' },
  'matches.score': { sr: 'Rezultat', en: 'Score' },
  'matches.status': { sr: 'Status', en: 'Status' },
  'matches.scheduled': { sr: 'Raspored', en: 'Scheduled' },
  'matches.embed': { sr: 'Embed', en: 'Embed' },
  'matches.zapisnik': { sr: 'Zapisnik', en: 'Report' },
  'matches.official': { sr: 'Zvanično', en: 'Official' },
  'matches.publish': { sr: 'Objavi zvanično', en: 'Publish official' },
  'matches.publishing': { sr: 'Objavljivanje…', en: 'Publishing…' },
  'matches.highlight': { sr: 'Napravi highlight', en: 'Create highlight' },
  'matches.copyStory': { sr: 'Kopiraj story', en: 'Copy story' },
  'matches.copied': { sr: 'Kopirano', en: 'Copied' },
  'matches.empty': { sr: 'Još nema utakmica na licenci.', en: 'No entitled matches yet.' },
  'matches.emptyFilter': { sr: 'Nema ničega u ovom filteru. Probaj Sve.', en: 'Nothing in this filter. Try All.' },
  'matches.prev': { sr: '← Prethodna', en: '← Previous' },
  'matches.next': { sr: 'Sledeća →', en: 'Next →' },
  'matches.shown': { sr: '{from}–{to} od {total}', en: '{from}–{to} of {total}' },
  'matches.shownNone': { sr: '0 prikazano', en: '0 shown' },
  'matches.embedTitle': { sr: 'Embed snippet', en: 'Embed snippet' },
  'matches.copy': { sr: 'Kopiraj', en: 'Copy' },
  'matches.close': { sr: 'Zatvori', en: 'Close' },
  'matches.delivery': { sr: 'Dostava', en: 'Delivery' },
  'matches.lastAlert': { sr: 'Poslednji alert', en: 'Last alert' },
  'matches.lastReel': { sr: 'Poslednji reel', en: 'Last reel' },
  'matches.inbox': { sr: 'Inbox →', en: 'Inbox →' },
  'matches.preview': { sr: 'Pregled', en: 'Preview' },
  'matches.qc': { sr: 'QC', en: 'QC' },
  'feed.noLive': { sr: 'Nema uživo', en: 'No live match' },
  'feed.liveN': { sr: '{n} uživo', en: '{n} live' },
  'feed.last': { sr: 'Poslednji', en: 'Last' },
  'feed.quietUntil': { sr: 'Tišina do {until}, {n} reels na čekanju', en: 'Quiet until {until}, {n} reels queued' },
  'feed.morning': { sr: '{n} reels čeka morning pack', en: '{n} reels waiting morning pack' },
  'feed.scout': { sr: 'Scout', en: 'Scout' },

  'videos.sub': { sr: 'Pusti, preuzmi i arhiviraj gotove video.', en: 'Play, download, and file finished videos.' },
  'videos.create': { sr: 'Napravi highlight', en: 'Create highlight' },
  'videos.stitch': { sr: 'Sastavi iz klipova', en: 'Stitch from clips' },
  'videos.reviewN': { sr: 'Čeka review ({n})', en: 'Needs review ({n})' },
  'videos.needsReview': { sr: 'Čeka review', en: 'Needs review' },
  'videos.anyStatus': { sr: 'Svi statusi', en: 'Any status' },
  'videos.ready': { sr: 'Spreman', en: 'Ready' },
  'videos.processing': { sr: 'Obrada', en: 'Processing' },
  'videos.failed': { sr: 'Neuspelo', en: 'Failed' },
  'videos.search': { sr: 'Pretraga', en: 'Search' },
  'videos.status': { sr: 'Status', en: 'Status' },
  'videos.created': { sr: 'Kreirano', en: 'Created' },
  'videos.sort': { sr: 'Sort', en: 'Sort' },
  'videos.anyTime': { sr: 'Bilo kada', en: 'Any time' },
  'videos.7d': { sr: 'Poslednjih 7 dana', en: 'Last 7 days' },
  'videos.30d': { sr: 'Poslednjih 30 dana', en: 'Last 30 days' },
  'videos.newest': { sr: 'Najnovije', en: 'Newest' },
  'videos.oldest': { sr: 'Najstarije', en: 'Oldest' },
  'videos.name': { sr: 'Ime', en: 'Name' },
  'videos.longest': { sr: 'Najduže', en: 'Longest' },
  'videos.folders': { sr: 'Folderi', en: 'Folders' },
  'videos.all': { sr: 'Svi video', en: 'All videos' },
  'videos.unsorted': { sr: 'Neraspoređeno', en: 'Unsorted' },
  'videos.newFolder': { sr: 'Novi folder', en: 'New folder' },
  'videos.reset': { sr: 'Reset filtera', en: 'Reset filters' },

  'usage.kicker': { sr: 'Nalog', en: 'Account' },
  'usage.title': { sr: 'Potrošnja', en: 'Usage' },
  'usage.sub': { sr: 'Saobraćaj, licenca, tihi sati i sponzor na widgetima.', en: 'Traffic, license, quiet hours, and the widget sponsor.' },
  'usage.reelsLeft': { sr: 'Ostalo ti je {n} reels ovog meseca', en: '{n} reels left this month' },
  'usage.reelsUsed': { sr: '{used} / {quota} reels ovog meseca', en: '{used} / {quota} reels this month' },
  'usage.reelsUnlimited': { sr: 'Reels ovog meseca: bez limita ({used} iskorišćeno)', en: 'Reels this month: unlimited ({used} used)' },
  'usage.mounts': { sr: 'Montaže (30d)', en: 'Mounts (30d)' },
  'usage.views': { sr: 'Pregledi (30d)', en: 'Views (30d)' },
  'usage.requests': { sr: 'Zahtevi danas', en: 'Requests today' },
  'usage.keys': { sr: 'Ključevi danas', en: 'Keys today' },
  'usage.hourApi': { sr: 'API (1h)', en: 'API (1h)' },
  'usage.hourOk': { sr: 'Webhook OK (1h)', en: 'Webhook OK (1h)' },
  'usage.hourFail': { sr: 'Webhook fail (1h)', en: 'Webhook fail (1h)' },
  'usage.lastDelivery': { sr: 'Poslednja dostava', en: 'Last delivery' },
  'usage.setupOpen': { sr: 'Setup nije gotov — dodaj sajt, webhook i replay gol. Otvori setup →', en: 'Setup is not finished — add a site, a webhook, and replay a goal. Open setup →' },
  'usage.license': { sr: 'Licenca', en: 'License' },
  'usage.pack': { sr: 'Paket', en: 'Pack' },
  'usage.pbp': { sr: 'PBP', en: 'PBP' },
  'usage.sports': { sr: 'Sportovi', en: 'Sports' },
  'usage.competitions': { sr: 'Takmičenja', en: 'Competitions' },
  'usage.delay': { sr: 'Delay', en: 'Delay' },
  'usage.club': { sr: 'Klub', en: 'Club' },
  'usage.league': { sr: 'Liga', en: 'League' },
  'usage.allSports': { sr: 'Svi sportovi', en: 'All sports' },
  'usage.allComps': { sr: 'Sva takmičenja', en: 'All competitions' },
  'usage.delivery': { sr: 'Dostava', en: 'Delivery' },
  'usage.deliveryHint': { sr: 'Live gol ostaje live. Highlight posle kasnog FT čeka jutarnji sat umesto 00:40.', en: 'Live goals stay live. Late-FT highlights wait for the morning hour instead of 00:40.' },
  'usage.timezone': { sr: 'Vremenska zona', en: 'Timezone' },
  'usage.quietFrom': { sr: 'Tišina od', en: 'Quiet from' },
  'usage.quietUntil': { sr: 'Tišina do', en: 'Quiet until' },
  'usage.morningHour': { sr: 'Jutarnji sat', en: 'Morning hour' },
  'usage.holdReels': { sr: 'Drži reelove u tihim satima', en: 'Hold reels in quiet hours' },
  'usage.batchMorning': { sr: 'FT highlight ide u morning pack', en: 'Batch FT highlights until morning' },
  'usage.brand': { sr: 'Sponzor na widgetima', en: 'Sponsor on widgets' },
  'usage.brandHint': { sr: 'Logo na live-score, tabeli i trackeru. White-label je isključivanje Powered by — to nije isto.', en: 'Logo on live-score, standings, and tracker. White-label is turning off Powered by — not the same thing.' },
  'usage.logo': { sr: 'Logo', en: 'Logo' },
  'usage.logoDrop': { sr: 'Ubaci sliku ili klikni za upload', en: 'Drop an image or click to upload' },
  'usage.logoHint': { sr: 'PNG, SVG, JPG · do 4 MB', en: 'PNG, SVG, JPG · up to 4 MB' },
  'usage.logoReplace': { sr: 'Zameni', en: 'Replace' },
  'usage.logoRemove': { sr: 'Ukloni', en: 'Remove' },
  'usage.logoBadType': { sr: 'Ubaci PNG, SVG, JPG ili WebP.', en: 'Upload a PNG, SVG, JPG, or WebP.' },
  'usage.logoTooBig': { sr: 'Slika je prevelika. Probaj manji fajl.', en: 'Image is too large. Try a smaller file.' },
  'usage.sponsorLabel': { sr: 'Potpis', en: 'Caption' },
  'usage.sponsorLabelPh': { sr: 'npr. presented by ARKUS', en: 'e.g. presented by ARKUS' },
  'usage.poweredBy': { sr: 'Prikaži Powered by Origo', en: 'Show Powered by Origo' },
  'usage.preview': { sr: 'Pregled footera', en: 'Footer preview' },
  'usage.save': { sr: 'Sačuvaj dostavu i brend', en: 'Save delivery + brand' },
  'usage.saving': { sr: 'Čuvam…', en: 'Saving…' },
  'usage.saved': { sr: 'Sačuvano.', en: 'Saved.' },
  'usage.nearLimit': { sr: 'Blizu si limita zahteva na planu. Traži veći QPS od account managera.', en: 'You are approaching this plan’s request volume. Ask your account manager for a higher QPS cap.' },
  'usage.last7': { sr: 'Poslednjih 7 dana', en: 'Last 7 days' },
  'usage.noTraffic': { sr: 'Još nema saobraćaja. Pozovi API ili otvori widget preview.', en: 'No traffic yet. Call the API or open a widget preview.' },
  'usage.byWidget': { sr: 'Po widgetu', en: 'By widget' },
  'usage.byClub': { sr: 'Po klubu', en: 'By club' },
  'usage.noEmbed': { sr: 'Još nema embed saobraćaja.', en: 'No embed traffic yet.' },

  'webhooks.inbox': { sr: 'Inbox', en: 'Inbox' },
  'webhooks.deliveries': { sr: 'Isporuke', en: 'Deliveries' },
  'webhooks.lastReal': { sr: 'Poslednji pravi event', en: 'Last real event' },
  'webhooks.lastRealNone': { sr: 'Još nema pravog eventa — samo ping ili test.', en: 'No real event yet — only ping or test.' },
  'webhooks.lastRealHint': { sr: 'Ping i Test/Replay se ne računaju. Ovo je poslednji live delivery.', en: 'Ping and Test/Replay do not count. This is the last live delivery.' },

  'setup.kicker': { sr: 'Prvi sat', en: 'First hour' },
  'setup.title': { sr: 'Setup', en: 'Setup' },
  'setup.subLeague': { sr: 'Go-live lige: kola, klubovi, replay po destinaciji, white-label, sponsor, kolo pack.', en: 'League go-live: rounds, clubs, one replay per destination, white-label, sponsor, kolo pack.' },
  'setup.subClub': { sr: 'Go-live kluba: host, widget key, Telegram, lozinka. Embed pack je na Početnoj.', en: 'Club go-live: host, widget key, Telegram, password. Embed pack lives on Home.' },
  'setup.clubUnder': { sr: 'Klub portal pod', en: 'Club portal under' },
  'setup.only': { sr: 'samo', en: 'only' },
  'setup.leagueLogin': { sr: 'Liga nalog. Klub portale dodaješ sa', en: 'League login. Add club portals from' },
  'setup.clubs': { sr: 'Klubovi', en: 'Clubs' },
  'setup.host': { sr: 'Dodaj host za widget', en: 'Add widget host' },
  'setup.webhook': { sr: 'Dodaj webhook', en: 'Add webhook' },
  'setup.replay': { sr: 'Replay gola', en: 'Replay a goal' },
  'setup.koloPack': { sr: 'Kolo pack', en: 'Kolo pack' },
  'setup.koloPackHint': { sr: 'Štampa / CSV celog kola — zapisnici, strelci, 7m.', en: 'Print / CSV for a whole round — reports, scorers, 7m.' },
  'setup.openRounds': { sr: 'Otvori kola →', en: 'Open rounds →' },
  'setup.clubHome': { sr: 'Početna kluba', en: 'Club home' },
  'setup.clubHomeHint': { sr: 'Sledeći meč, embed pack (live + tabela + story), sastav, lozinka, share.', en: 'Next match, embed pack (live + table + story), squad, password, share.' },
  'setup.openHome': { sr: 'Otvori početnu →', en: 'Open home →' },
  'setup.password': { sr: 'Reset lozinke', en: 'Reset password' },
  'setup.passwordHint': { sr: 'Promeni lozinku na Početnoj ili u Nalogu.', en: 'Change the password on Home or in Account.' },
  'setup.skip': { sr: 'Preskoči na utakmice', en: 'Skip to matches' },
  'setup.done': { sr: 'Gotovo', en: 'Done' },
  'setup.todo': { sr: 'Todo', en: 'Todo' },
  'setup.complete': { sr: 'Setup završen', en: 'Setup complete' },
  'setup.mark': { sr: 'Označi setup gotovim', en: 'Mark setup complete' },
  'setup.incomplete': { sr: 'Checklist nije gotov', en: 'Checklist incomplete' },

  'clubs.kicker': { sr: 'Paket lige', en: 'League package' },
  'clubs.title': { sr: 'Klubovi', en: 'Clubs' },
  'clubs.sub': { sr: 'Dodaj klub, resetuj lozinku, suspenduj, promeni tim, kopiraj pack (live + tabela + story).', en: 'Add a club, reset password, suspend, change the team, copy the pack (live + table + story).' },
  'clubs.clubBlocked': { sr: 'Ovaj nalog je klub. Početna je tvoj portal — liga dodaje klubove.', en: 'This login is a club. Home is your portal — only the league adds clubs.' },
  'clubs.goHome': { sr: 'Idi na početnu →', en: 'Go to home →' },
};

function interpolate(s: string, vars?: Record<string, string | number>): string {
  if (!vars) return s;
  return s.replace(/\{(\w+)\}/g, (_, k: string) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
}

export function translate(locale: Locale, key: string, vars?: Record<string, string | number>): string {
  const row = dict[key];
  const raw = row?.[locale] ?? row?.en ?? row?.sr ?? key;
  return interpolate(raw, vars);
}

export function useT() {
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);
  return {
    locale,
    setLocale,
    t: (key: string, vars?: Record<string, string | number>) => translate(locale, key, vars),
  };
}
